import { render, staticRenderFns } from "./drill-down-chart.vue?vue&type=template&id=23b98b4f&scoped=true"
import script from "./drill-down-chart.ts?vue&type=script&lang=ts&external"
export * from "./drill-down-chart.ts?vue&type=script&lang=ts&external"
import style0 from "./drill-down-chart.scss?vue&type=style&index=0&id=23b98b4f&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b98b4f",
  null
  
)

export default component.exports